export const environment = {
  name: 'staging',
  production: false,
  productType: 'mobile-app',
  webClientId: '834934412195-k6f4mn5cu265p185emgbdk0j832faisq.apps.googleusercontent.com',
  iOSClientId: '834934412195-775cmjhi7ak2bmvmp8fp1qccbkrpaq47.apps.googleusercontent.com',
  token_auth_config: {
    apiBase: 'https://api.staging.europe.inyova.cloud'
  },
  apiUrl: 'https://api.staging.europe.inyova.cloud/api/v2/customers',
  apiUrlV3: 'https://api.staging.europe.inyova.cloud/api/v3',
  apiUrlV4: 'https://api.staging.europe.inyova.cloud/api/v4',
  amplitudeApiKey: '3a9b51c86d614e44369f3e2b8e78e026',
  customersApp: {
    ch: 'https://staging.inyova.ch',
    de: 'https://staging.inyova.de'
  }
};
